import { useRef, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";

export default function CakeModel() {
  const ref = useRef();
  const { scene } = useGLTF("/models/cake.glb");

  useEffect(() => {
  const box = new THREE.Box3().setFromObject(scene);
  const size = new THREE.Vector3();
  const center = new THREE.Vector3();

  box.getSize(size);
  box.getCenter(center);
  scene.position.sub(center);

  scene.position.y -= size.y * 0.15; // 🔥 LOWER it
  const scale = 2.2 / Math.max(size.x, size.y, size.z);
  scene.scale.setScalar(scale);
}, [scene]);

useFrame(() => {
  if (ref.current) {
    ref.current.rotation.y += 0.0006; // 🔥 ultra slow
  }
});


  useFrame(() => {
    if (ref.current) {
      ref.current.rotation.y += 0.001; // 🔥 VERY slow = premium
    }
  });

  return <primitive ref={ref} object={scene} />;
}

useGLTF.preload("/models/cake.glb");
